import Vue from "vue";
import {
  ToastPlugin,
  ModalPlugin,
  BootstrapVueIcons,
  IconsPlugin,
} from "bootstrap-vue";
import VueCompositionAPI from "@vue/composition-api";
import BootstrapVue from "bootstrap-vue";
import VueMoment from "vue-moment";
import moment from "moment-timezone";
import Echo from "laravel-echo";

//import i18n from '@/libs/i18n'
import router from "./router";
import store from "./store";
import App from "./App.vue";

// Global Components
import "./global-components";

// 3rd party plugins
import "@axios";
import "@/libs/acl";
import "@/libs/portal-vue";
import "@/libs/clipboard";
import "@/libs/toastification";
import "@/libs/sweet-alerts";
import "@/libs/vue-select";
import "@/libs/tour";

import Directives from "./directives";
Vue.use(Directives);

// BSV Plugin Registration
Vue.use(ToastPlugin);
Vue.use(ModalPlugin);

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(IconsPlugin);

Vue.use(VueMoment, {
  moment,
});

// Composition API
Vue.use(VueCompositionAPI);

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require("@core/assets/fonts/feather/iconfont.css"); // For form-wizard

// import core styles
require("@core/scss/core.scss");

// import assets styles
require("@/assets/scss/style.scss");

// import sweet alert styles
require("@core/scss/vue/libs/vue-sweetalert.scss");

window.Pusher = require("pusher-js");

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true,
//     auth: {
//       headers: {
//           Authorization: 'Bearer ' + localStorage.getItem('accessToken')
//       },
//   },
// });

window.NotificationSound = new Audio("/sounds/swiftly.mp3");

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  //i18n,
  render: (h) => h(App),
}).$mount("#app");
